import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs";

import { environment } from "src/environments/environment";
import { AppSessionService } from "../app-session/app-session.service";

import { FilterOperation } from "src/app/models/custom-table/custom-table.model";

import { setAdvancedFilterQuery, setSimpleFilterQuery } from "../../utils/tableUtils";
import { hexToRgb } from "../../utils/colorUtils";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class ReportsService {
  private BASE_URL = this.appSession.baseUrl + "/api/v1/reports";

  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  getReports(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Content-type",
      "application/x-www-form-urlencoded; "
    );

    const url = `${this.appSession.baseUrl + "/api/v1/reports"}`;
    return this.http.get(url, { headers });
  }

  generateReport(report: any, options: any, exportFormat: any) {
    const currLocale = localStorage.getItem("locale");
    const username = localStorage.getItem("username");
    const primary = document.documentElement.style.getPropertyValue("--primary");
    const rgbColor = hexToRgb(primary);
    const appVers = environment?.appVersion;

    const data = {
      settings: {
        formatter: options.formatter,
        format: exportFormat,
        theme: {
          primaryColor: rgbColor,
          alternateRowColors: true,
          headerLine: ["This is a demo"],
        },
        header: {
          appVersion: appVers,
          printedBy: username,
        },
        showDetails: true,
        showSummary: options?.showSummary || false,
        showSummaryGroup: true,
        showSummaryPageBreak: true,
      },
      groupBy: options.groupBy,
      sort: options.sort,
      filters: options.filters,
    };

    const headers = new HttpHeaders({
      "Content-type": "application/json",
      locale: currLocale,
    });

    const url = this.appSession.baseUrl + report?.endpoint;

    return this.http.put(url, data, { headers });
  }

  getReportsStatus(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    return this.http.get(
      this.buildDataUrl(paging, filteringArgs, sortingArgs, headers, "?"),
      { headers }
    );
  }

  getReportData(code: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.appSession.baseUrl + "/api/v1/reports"}/${code}`;
    return this.http.get(url, { headers });
  }

  private buildDataUrl(
    pagingArgs: any,
    filteringArgs: any,
    sortingArgs: any,
    header: HttpHeaders,
    path: string
  ): string {
    let baseQueryString = `${this.appSession.baseUrl + "/api/v1/reports/search"}${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = this._buildScrollExpression(pagingArgs);
    }
    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }

  private _buildScrollExpression(pagingArgs): string {
    const skip = pagingArgs.skip;
    const top = pagingArgs.top;
    const realSize = pagingArgs.realSize;

    if (top && top !== null) {
      return `real_size=${!!realSize}&offset=${skip}&limit=${top}`;
    } else {
      return `real_size=${!!realSize}&offset=${skip}`;
    }
  }
}
